import * as React from 'react'
import reactStringReplace from 'react-string-replace'
import { useIntersection } from 'react-use'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'

import { FigsScrubsAreIcon } from './icon'
import { Body, Highlight, IconWrap, MessageText, SlantedLine, Text } from './styles'

export const FigsScrubsAreSection: React.FC = () => {
  const ref = React.useRef(null)
  const intersection = useIntersection(ref as unknown as React.RefObject<HTMLElement>, {})

  const {
    pages: {
      product: { figsScrubsAre },
    },
  } = useTranslation()

  const inViewport = !!(intersection && intersection.intersectionRatio > 0)

  const richFigsScrubsAre = reactStringReplace(figsScrubsAre, /\*([^\*]+)\*/g, (match, _i) => {
    return <Highlight key={match}>{match}</Highlight>
  })

  return (
    <Body>
      <IconWrap {...{ ref }}>
        <FigsScrubsAreIcon {...{ inViewport }} />
      </IconWrap>
      <SlantedLine />
      <Text>
        <MessageText>{richFigsScrubsAre}</MessageText>
      </Text>
    </Body>
  )
}
